<h2 mat-dialog-title>Change Password</h2>

<div mat-dialog-content>
    <form [formGroup]="changePasswordForm" (ngSubmit)="submit()" class="dialog-form">

        <!-- Current password -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Current Password</mat-label>
            <input
                matInput
                [type]="showOld ? 'text' : 'password'"
                formControlName="oldPassword"
                required
            />
            <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="showOld = !showOld"
                [attr.aria-label]="'Toggle current password visibility'"
            >
                <mat-icon>{{ showOld ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
        </mat-form-field>

        <!-- New password -->
        <div class="new-password-section">
            <mat-form-field appearance="outline" class="full-width compact-field">
                <mat-label>New Password</mat-label>
                <input
                    matInput
                    [type]="showNew ? 'text' : 'password'"
                    formControlName="newPassword"
                    (input)="onPasswordInput()"
                    required
                />
                <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    (click)="showNew = !showNew"
                    [attr.aria-label]="'Toggle new password visibility'"
                >
                    <mat-icon>{{ showNew ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>

                <mat-error *ngIf="changePasswordForm.hasError('samePassword')">
                    New password cannot be the same as the current one.
                </mat-error>
            </mat-form-field>

            <!-- Strength meter line -->
            <div class="strength-meter">
                <div class="strength-fill" [ngClass]="getStrengthClass()"></div>
            </div>
            <div class="strength-info">
                <span class="strength-label">{{ strengthLabel }}</span>
            </div>

            <!-- Minimal color-coded requirement badges -->
            <div class="req-badges">
                <div class="req-badge" [class.met]="requirements.length">14+ chars</div>
                <div class="req-badge" [class.met]="requirements.upper">Uppercase</div>
                <div class="req-badge" [class.met]="requirements.lower">Lowercase</div>
                <div class="req-badge" [class.met]="requirements.number">Number</div>
                <div class="req-badge" [class.met]="requirements.special">Symbol</div>
            </div>
        </div>

        <!-- Confirm password -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Confirm New Password</mat-label>
            <input
                matInput
                [type]="showConfirm ? 'text' : 'password'"
                formControlName="confirmPassword"
                required
            />
            <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="showConfirm = !showConfirm"
                [attr.aria-label]="'Toggle confirm password visibility'"
            >
                <mat-icon>{{ showConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>

            <mat-error *ngIf="changePasswordForm.hasError('passwordsMismatch')">
                Passwords do not match.
            </mat-error>
        </mat-form-field>

        <!-- Messages -->
        <div class="messages">
            <mat-error *ngIf="errorMessage">{{ errorMessage }}</mat-error>
            <mat-hint *ngIf="successMessage" class="success">{{ successMessage }}</mat-hint>
        </div>
    </form>
</div>

<!-- Actions -->
<div mat-dialog-actions class="dialog-actions">
    <button
        mat-stroked-button
        (click)="cancel()"
        [disabled]="loading"
        class="action-btn cancel-btn"
    >
        Cancel
    </button>

    <button
        mat-raised-button
        color="primary"
        (click)="submit()"
        [disabled]="loading"
        class="action-btn submit-btn"
    >
        {{ loading ? 'Changing...' : 'Change Password' }}
    </button>
</div>
